import {
  MockEventButton,
  type IMockEventOption
} from '../MockEventButton/MockEventButton';
import { useAppSelector } from '@/store/reduxHooks';
import { emitMockSocketEvent } from '@/services/mercure/mockSocketEvents';
import {
  buildMockOrderEvent,
  type TOrderMockScenario
} from '@/utils/buildMockOrderEvent';
import { isCallMockAllowed } from '@/utils/isCallMockAllowed';
import { getOrderSequence } from '@/utils/getOrderSequence';

const BUTTON_LABEL = 'Тест заказа';
const BUTTON_LABEL_SHORT = 'Заказ';
const PANEL_TITLE = 'Эмуляция события заказа';

const SCENARIOS: readonly IMockEventOption<TOrderMockScenario>[] = [
  {
    id: 'newest',
    label: 'Новый заказ — самый свежий',
    hint: 'номер выше всех: тост, звук, строка сверху с розовым угасанием'
  },
  {
    id: 'backdated',
    label: 'Новый заказ — задним числом',
    hint: 'номер ниже всех: строка встаёт в конец списка, а не наверх'
  }
];

/**
 * Тестовая кнопка эмуляции события нового заказа. Видна только при включённом
 * флаге VITE_CALL_MOCK_ALLOW. Отправляет сырой кадр в общий канал эмуляции,
 * откуда он проходит тот же разбор, что и настоящее событие Mercure.
 *
 * Номер мокового заказа подбирается от того, что сейчас в таблице, — иначе
 * невозможно показать, что заказ встаёт на естественную позицию. Номер — хвост
 * `formated_id`: `id` заказа с PAR-5189 не приходит.
 */
export const OrderMockButton: React.FC = () => {
  const serverOrders = useAppSelector((state) => state.orders.orders);
  const liveOrders = useAppSelector((state) => state.orders.liveOrders);

  if (!isCallMockAllowed()) {
    return null;
  }

  const handleSelect = (scenario: TOrderMockScenario): void => {
    const existingSequences = [...serverOrders, ...liveOrders].map(
      getOrderSequence
    );

    emitMockSocketEvent(buildMockOrderEvent(scenario, existingSequences));
  };

  return (
    <MockEventButton
      label={BUTTON_LABEL}
      shortLabel={BUTTON_LABEL_SHORT}
      title={PANEL_TITLE}
      options={SCENARIOS}
      onSelect={handleSelect}
    />
  );
};
